import { IDashboardActionTypes } from "../../action-types/dashboard/IDashboardActions";
import { IDashboardReducer } from "../../reducer-model/dashboard/IDashboardReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: IDashboardReducer = {
    status: eReducerStatusBase.is_not_initialization,
    dashboard: {
        tongGiaoVien: {
            tong_gv: 0,
        },
        tongSinhVienCacHes: [],
        tongSinhVienTotNghiepCacHes: [],
        tinhTrangTotNghiepTheoNganhs: [],
        sinhVienTheoTrangThaiHocs: [],
        ketQuaHocTapToanKhoas: [],
    },
    selectedLanXet: null,
    selectedNamXet: '',
}

export const dashboardReducer = (state: IDashboardReducer = iniState, action: IDashboardActionTypes): IDashboardReducer => {
    switch (action.type) {
        case "DASHBOARD_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "DASHBOARD_LOAD_SUCCESS":
            // Tự động chọn lan_xet và nam_xet gần đây nhất khi load dữ liệu
            const allGraduationData = action.payload.tinhTrangTotNghiepTheoNganhs || [];
            let autoSelectedLanXet = state.selectedLanXet;
            let autoSelectedNamXet = state.selectedNamXet;
            
            if (allGraduationData.length > 0 && (state.selectedLanXet === null || state.selectedNamXet === '')) {
                const latestRecord = allGraduationData.reduce((latest, current) => {
                    if (current.nam_xet > latest.nam_xet || 
                        (current.nam_xet === latest.nam_xet && current.lan_xet > latest.lan_xet)) {
                        return current;
                    }
                    return latest;
                }, allGraduationData[0]);
                
                autoSelectedLanXet = latestRecord.lan_xet;
                autoSelectedNamXet = latestRecord.nam_xet;
            }
            
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                dashboard: action.payload,
                selectedLanXet: autoSelectedLanXet,
                selectedNamXet: autoSelectedNamXet,
            };
        case "DASHBOARD_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "DASHBOARD_SET_SELECTED_LAN_XET":
            return {
                ...state,
                selectedLanXet: action.payload,
            };
        case "DASHBOARD_SET_SELECTED_NAM_XET":
            return {
                ...state,
                selectedNamXet: action.payload,
            };
        default:
            return state;
    }
}